"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Localize_1 = require("../../gen-src/Localize");
var StaticInitializers_1 = require("./StaticInitializers");
exports.FIFTEEN_MINUTES = 15;
exports.HALF_HOUR = 30;
exports.MINUTES_IN_HOUR = 60;
exports.TWO_HOURS = 2 * exports.MINUTES_IN_HOUR;
exports.FOUR_HOURS = 4 * exports.MINUTES_IN_HOUR;
exports.SIX_HOURS = 6 * exports.MINUTES_IN_HOUR;
exports.EIGHT_HOURS = 8 * exports.MINUTES_IN_HOUR;
exports.TWELVE_HOURS = 12 * exports.MINUTES_IN_HOUR;
exports.ONE_DAY = 24 * exports.MINUTES_IN_HOUR;
var RecurrenceMode;
(function (RecurrenceMode) {
    RecurrenceMode["DataRefresh"] = "On Data Refresh";
    RecurrenceMode["TimeRecurrence"] = "Specified Time";
})(RecurrenceMode = exports.RecurrenceMode || (exports.RecurrenceMode = {}));
;
var RecurrenceType;
(function (RecurrenceType) {
    RecurrenceType["Hourly"] = "Hourly";
    RecurrenceType["Daily"] = "Daily";
    RecurrenceType["Weekly"] = "Weekly";
    RecurrenceType["Monthly"] = "Monthly";
})(RecurrenceType = exports.RecurrenceType || (exports.RecurrenceType = {}));
;
exports.RecurrenceMinutesNumber = {
    FifteenMinutes: exports.FIFTEEN_MINUTES,
    HalfHour: exports.HALF_HOUR,
    OneHour: exports.MINUTES_IN_HOUR,
    TwoHour: exports.TWO_HOURS,
    FourHour: exports.FOUR_HOURS,
    SixHour: exports.SIX_HOURS,
    EightHour: exports.EIGHT_HOURS,
    TwelveHour: exports.TWELVE_HOURS,
    OneDay: exports.ONE_DAY
};
exports.RecurrenceMinutes = {
    FifteenMinutes: 'FifteenMinutes',
    HalfHour: 'HalfHour',
    OneHour: 'OneHour',
    TwoHour: 'TwoHour',
    FourHour: 'FourHour',
    SixHour: 'SixHour',
    EightHour: 'EightHour',
    TwelveHour: 'TwelveHour',
    OneDay: 'OneDay'
};
var RecurrenceDaysOfTheWeek;
(function (RecurrenceDaysOfTheWeek) {
    RecurrenceDaysOfTheWeek["Sun"] = "Sun";
    RecurrenceDaysOfTheWeek["Mon"] = "Mon";
    RecurrenceDaysOfTheWeek["Tue"] = "Tue";
    RecurrenceDaysOfTheWeek["Wed"] = "Wed";
    RecurrenceDaysOfTheWeek["Thu"] = "Thu";
    RecurrenceDaysOfTheWeek["Fri"] = "Fri";
    RecurrenceDaysOfTheWeek["Sat"] = "Sat";
})(RecurrenceDaysOfTheWeek = exports.RecurrenceDaysOfTheWeek || (exports.RecurrenceDaysOfTheWeek = {}));
;
var RecurrenceConverters = /** @class */ (function () {
    function RecurrenceConverters() {
    }
    /* tslint:disable:no-bitwise */
    /**
     * Converts from the 32 bit integer into a array of day numbers.
     * @param recurrenceDayOfMonth - 32 integer in decimal string form
     * @return array of day numbers. e.g. integer 7 would have it's first, second and third bits set to 1
     * That would yield ("7") => [1,2,3]. See unit tests for more examples.
     * */
    RecurrenceConverters.toDaysOfMonthArr = function (recurrenceDayOfMonth) {
        if (recurrenceDayOfMonth === undefined || recurrenceDayOfMonth === null || recurrenceDayOfMonth === '') {
            return [];
        }
        var daysOfMonthMask = parseInt(recurrenceDayOfMonth, 10);
        if (isNaN(daysOfMonthMask)) {
            throw recurrenceDayOfMonth + ' is an invalid daysOfMonthMask';
        }
        var resultDaysOfMothArr = [];
        // special case of Last
        if (daysOfMonthMask === 0) {
            resultDaysOfMothArr.push(0);
        }
        var dayNum = 1;
        while (daysOfMonthMask > 0) {
            if (daysOfMonthMask & 1) {
                resultDaysOfMothArr.push(dayNum);
            }
            dayNum++;
            daysOfMonthMask = daysOfMonthMask >>> 1;
        }
        return resultDaysOfMothArr;
    };
    /**
     * Converts an array of day numbers into a 32 bit integer mask.
     * @param daysOfMonth - array of day numbers from 1 to 31.
     * @return 32 bit integer mask. e.g. integer 7 would have it's first, second and third bits set to 1
     * That would yield ([1,2,3]) => 7. See unit tests for more examples.
     * */
    RecurrenceConverters.toDaysOfMonthMask = function (daysOfMonth) {
        if (!daysOfMonth) {
            throw 'daysOfMonth should be non-null/non-undefined (truthy)';
        }
        if (daysOfMonth.length === 0) {
            throw "daysOfMonth should be non-empty: " + daysOfMonth;
        }
        var daysOfMonthMask = 0;
        // special case
        if (daysOfMonth.indexOf(0) >= 0) {
            return 0;
        }
        for (var i = 0; i < daysOfMonth.length; i++) {
            daysOfMonthMask |= RecurrenceConverters.getDayOfMonthMask(daysOfMonth[i]);
        }
        return daysOfMonthMask;
    };
    RecurrenceConverters.getDayOfMonthMask = function (dayOfMonth) {
        if (dayOfMonth > 31 || dayOfMonth === undefined) {
            throw 'Invalid day in a month:' + dayOfMonth;
        }
        var dayOfMonthMask = 1;
        if (dayOfMonth > 1) {
            dayOfMonthMask = dayOfMonthMask << (dayOfMonth - 1);
        }
        return dayOfMonthMask;
    };
    /* tslint:enable:no-bitwise */
    RecurrenceConverters.getDayOfWeek = function (day) {
        var dayNum = day.getDay();
        switch (dayNum) {
            case 0:
                return [RecurrenceDaysOfTheWeek.Sun];
            case 1:
                return [RecurrenceDaysOfTheWeek.Mon];
            case 2:
                return [RecurrenceDaysOfTheWeek.Tue];
            case 3:
                return [RecurrenceDaysOfTheWeek.Wed];
            case 4:
                return [RecurrenceDaysOfTheWeek.Thu];
            case 5:
                return [RecurrenceDaysOfTheWeek.Fri];
            case 6:
                return [RecurrenceDaysOfTheWeek.Sat];
            default:
                return [];
        }
    };
    RecurrenceConverters.recurrenceDayToDescriptionString = function (recurrenceDayOfMonth) {
        switch (recurrenceDayOfMonth) {
            case 1:
                return Localize_1.Messages.RecurrenceMonthlyOnFirst();
            case 2:
                return Localize_1.Messages.RecurrenceMonthlyOnSecond();
            case 3:
                return Localize_1.Messages.RecurrenceMonthlyOnThird();
            case 4:
                return Localize_1.Messages.RecurrenceMonthlyOnFourth();
            case 5:
                return Localize_1.Messages.RecurrenceMonthlyOnFifth();
            case 0:
                return Localize_1.Messages.RecurrenceMonthlyOnLast();
            default:
                return Localize_1.Messages.RecurrenceOnDay();
        }
    };
    // This is supposedly not the "optimal" cloning method
    // https://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript
    // But even though there are tests to ensure it works as expected, the Object.assign approach doesn't seem to work
    RecurrenceConverters.clone = function (x) {
        return JSON.parse(JSON.stringify(x));
    };
    RecurrenceConverters.castScheduleToRecurrence = function (originalSchedule) {
        // Cloned to ensure the original object is not modified
        var schedule = RecurrenceConverters.clone(originalSchedule);
        var recurrence = {
            // tslint:disable-next-line: no-any
            recurrenceDetails: schedule.scheduleDetails,
            recurrenceMode: RecurrenceMode.TimeRecurrence,
            recurrenceType: schedule.scheduleType,
        };
        var daysOfWeekDefined = 'recurrenceDaysOfWeek' in recurrence.recurrenceDetails;
        switch (recurrence.recurrenceType) {
            case RecurrenceType.Hourly:
                // SSS expects both Hourly and Daily schedules to have recurrenceDaysOfWeek to be set. In the Admin Schedules these schedule
                // types did not have those values set, and that was interpretted to mean "every day of the week"
                if (!daysOfWeekDefined || recurrence.recurrenceDetails.recurrenceDaysOfWeek.length === 0) {
                    recurrence.recurrenceDetails.recurrenceDaysOfWeek = StaticInitializers_1.StaticInitializers.DEFAULT_ALL_DAYS_A_WEEK();
                }
                break;
            case RecurrenceType.Daily:
                var dailyRecurrence = recurrence.recurrenceDetails;
                // SSS expects both Hourly and Daily schedules to have recurrenceDaysOfWeek to be set. In the Admin Schedules these schedule
                // types did not have those values set, and that was interpretted to mean "every day of the week"
                if (!daysOfWeekDefined || dailyRecurrence.recurrenceDaysOfWeek.length === 0) {
                    dailyRecurrence.recurrenceDaysOfWeek = StaticInitializers_1.StaticInitializers.DEFAULT_ALL_DAYS_A_WEEK();
                }
                // SSS expects end time to equal start time if the schedule runs "all day"
                if (!('endTime' in recurrence.recurrenceDetails)) { // ends when it starts...
                    dailyRecurrence.endTime = dailyRecurrence.startTime;
                }
                // SSS expects recurrence minutes to be the number of minutes in a day if the schedule runs on a 24 hour recurrence (daily)
                if (!('recurrenceMinutes' in recurrence.recurrenceDetails)) {
                    dailyRecurrence.recurrenceMinutes = StaticInitializers_1.StaticInitializers.MINUTES_IN_DAY;
                }
                // SSS does not allow recurrence minutes to be less than 2 hours for daily. If it is it's a legacy schedule
                if (recurrence.recurrenceDetails.recurrenceMinutes < 60 * 2) {
                    dailyRecurrence.recurrenceMinutes = StaticInitializers_1.StaticInitializers.MINUTES_IN_DAY;
                }
                // SSS expects "all day" schedules to start when they end
                if (dailyRecurrence.recurrenceMinutes === StaticInitializers_1.StaticInitializers.MINUTES_IN_DAY) {
                    dailyRecurrence.endTime = dailyRecurrence.startTime;
                }
                break;
            case RecurrenceType.Weekly:
                if (!daysOfWeekDefined || recurrence.recurrenceDetails.recurrenceDaysOfWeek.length === 0) {
                    recurrence.recurrenceDetails.recurrenceDaysOfWeek = StaticInitializers_1.StaticInitializers.DEFAULT_ALL_DAYS_A_WEEK();
                }
                break;
            case RecurrenceType.Monthly:
                if (!daysOfWeekDefined) {
                    recurrence.recurrenceDetails.recurrenceDaysOfWeek = [];
                }
                break;
            default:
            // Do nothing
        }
        return recurrence;
    };
    return RecurrenceConverters;
}());
exports.RecurrenceConverters = RecurrenceConverters;
//# sourceMappingURL=Recurrence.js.map